import gql from "graphql-tag";

export const CreateCourseCategory = gql`
  mutation CreateCourseCategory($input: CreateCourseCategoryInput!) {
    createCourseCategory(input: $input) {
      cId
      title
      shopId
      createdUser
      description
      updatedTime
      createdTime
    }
  }
`;

export const UpdateCourseCategory = gql`
  mutation UpdateCourseCategory($input: UpdateCourseCategoryInput!) {
    updateCourseCategory(input: $input) {
      cId
      title
      shopId
      createdUser
      description
      updatedTime
      createdTime
    }
  }
`;
